﻿import { GroCommon, UploadImageModule, autoFitImages } from './common';


$(function () {
    MachineDetailPage.init();
    MachineAddPage.Init();
    MachineBookingService.Init();
});

(function ($) {
    $.fn.imgLoad = function (callback) {
        return this.each(function () {
            if (callback) {
                if (this.complete || /*for IE 10-*/ $(this).height() > 0) {
                    callback.apply(this);
                }
                else {
                    $(this).on('load', function () {
                        callback.apply(this);
                    });
                }
            }
        });
    };
})($);

const MachineDetailPage = (function () {
    var updated = false;

    var addUploadPopupEvent = function () {
        $('.avatar-icon').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.lm__block-metadata').find('.list-action-item').toggle();
        });
    };

    var fetchHoursForMachineLogMaster = function () {
        var serialNumber = $('#serialNumber').val();
        if (serialNumber) {
            var url = $('#datavaxtApiUrl').val();
            $.ajax({
                url: url,
                type: "GET",
                cache: false,
                data: { vin: serialNumber },
                dataType: 'json',
                success: function (result) {
                    if (result && result.engineHours > 0) {
                        var hours = result.engineHours.toFixed(0);
                        $('#total_hours').show().find('.total-text').html(hours + ' h');
                    } else {
                        $('#generic_banner').show();
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        } else {
            $('#generic_banner').show();
        }
    };

    var attachDeleteMachineEvent = function () {
        $('.remove-machine-button').click(function () {
            $('.delete-machine-alert').show();
        });
        $('#agree-remove-machine').click(function () {
            $('#form-remove-machine').submit();
        });
        $('#disagree-remove-machine').click(function () {
            $('.lm__modal-alert').hide();
        });

        var isFailed = $('#deleteFailed').val();
        if (isFailed === "True") {
            alert("Radera maskin misslyckades. Kontrollera igen!");
        }
    };

    var init = function () {
        addUploadPopupEvent();
        fetchHoursForMachineLogMaster();
        attachDeleteMachineEvent();
        autoFitImages(".machine-item__thumbnail-wrapper img");

        $(window).on('resize orientationchange', function () {
            if (!updated) {
                updated = true;
                setTimeout(function () {
                    autoFitImages(".machine-item__thumbnail-wrapper img");
                    updated = false;
                }, 100);
            }
        });

        $(window).trigger('resize');

        var machineUploadSettings = {
            fileSelector: "#machine-file",
            previewImgSelector: "#machine-picture",
            uploadBtnSelector: "#machine-uploadBtn",
            cancelUploadBtnSelector: "#machine-cancelUpload",
            linkSelector: "#machine-link",
            handleUrl: "/api/machine/machine-upload-avatar",
            isNeedToUpdateHeader: false,
            errorMessage: "Det uppstod ett fel när bilden skulle laddas upp. Var gör försök igen!",
            deleteLinkSelector: "#machine-deleteBtn",
            handleDeleteUrl: "/api/machine/machine-delete-avatar"
        };
        var userUploadImageModule = UploadImageModule(machineUploadSettings);
        userUploadImageModule.initDataForRequest([{ 'key': 'machineId', 'value': $('#machineId').val() }]);
        userUploadImageModule.initUploadFile();
        userUploadImageModule.initDeleteFile();
    };

    return {
        init: init,
        autoFitImages: autoFitImages(".machine-item__thumbnail-wrapper img")
    };

})();

const MachineAddPage = (function () {

    var machineDataTypes = {
        MachineType: 'MachineType',
        MachineBrand: 'MachineBrand',
        MachineModel: 'MachineModel'
    };
    var getCurrentlySelectedMachineTypeId = function () {
        return $('.machine-type-dropdown :selected').val();
    };
    var getCurrentlySelectedMachineBrandId = function () {
        return $('.machine-brand-dropdown :selected').val();
    };
    var getCurrentlySelectedMachineModel = function () {
        var selectedModel = {};
        selectedModel.Value = $('.machine-model-dropdown :selected').val();
        selectedModel.Text = $('.machine-model-dropdown :selected').text();
        return selectedModel;
    };
    var getMachineSerialNumber = function () {
        return $('#js-serialNumber').val();
    };
    var getMachineRegisteringNumber = function () {
        return $('#js-regNumber').val();
    };
    var clearValidationErrors = function() {
        $("#drop-machine-type-error").hide();
        $("#drop-machine-brand-error").hide();
        $("#drop-machine-model-error").hide();
        $("#machine-regNumber-error").hide();
        $("#machine-serialNumber-error").hide();
        $('#machine-add-error-list').hide();
    };
    var showErrors = function (errorList) {
        var errorListBox = $('#machine-add-error-list');
        if (errorList.length > 0) {
            errorListBox.show();
            errorListBox.html('');
            errorListBox.append(
                $('<li></li>').addClass('errors-list__header').append('Du måste se över')
            );
            $.each(errorList, function (i, error) {
                errorListBox.append(
                    $('<li></li>').append(error)
                );
            });
        }
        else {
            errorListBox.hide();
        }
    }
    var validateFormAddMachine = function () {

        clearValidationErrors();

        var machineTypeId = getCurrentlySelectedMachineTypeId();
        var machineBrandId = getCurrentlySelectedMachineBrandId();
        var machineModel = getCurrentlySelectedMachineModel();
        var regNumber = getMachineRegisteringNumber();
        var serialNumber = getMachineSerialNumber();

        var alphaNumericRegex = /^([a-zA-Z0-9]+)$/;

        var errorList = [];

        if ($.trim(machineTypeId) == '') {
            errorList.push("Typ");
            $("#drop-machine-type-error").show();
        }

        if ($.trim(machineBrandId) == '') {
            errorList.push("Märke");
            $("#drop-machine-brand-error").show();
        }

        if ($.trim(machineModel.Value) == '') {
            errorList.push("Modell");
            $("#drop-machine-model-error").show();
        }

        if (regNumber && (regNumber.length > 6 || !(alphaNumericRegex.test(regNumber)))) {
            errorList.push("Registreringsnummer");
            $("#machine-regNumber-error").show();
        }

        if (!serialNumber || $.trim(serialNumber) == '' ||  serialNumber.length > 17 || !(alphaNumericRegex.test(serialNumber))) {
            errorList.push("VIN/Serial");
            $("#machine-serialNumber-error").show();
        }

        if (errorList.length > 0) {
            showErrors(errorList);
            return false;
        }

        return true;
    }
    var dialogType = GroCommon.modalInfoClass;
    var hideLoader = function () {
        $('.loader-wrapper').hide();
        $('.loader-wrapper').parent().removeClass('disabled');
    }

    var showLoader = function () {
        $('.loader-wrapper').show();
        $('.loader-wrapper').parent().addClass('disabled');
    }

    var setSelectionList = function (selector, disabled) {
        var control = $(selector);
        if (control && control.length > 0) {
            control.val('').trigger('change'); // reset to first value
            $(control)[0].disabled = disabled;
        }
    }
    var resetSelectionLists = function (machineDataType) {

        clearValidationErrors();

        switch (machineDataType) {
            case machineDataTypes.MachineType:
            {
                setSelectionList('.machine-brand-dropdown', true);
                break;
            }
            case machineDataTypes.MachineBrand:
            {
                    setSelectionList('.machine-model-dropdown', true);
                break;
            }
            case machineDataTypes.MachineModel:
            {
                setSelectionList('.machine-model-dropdown', true);
                break;
            }
        }
    }
    var fetchMachineBrands = function (type) {
        showLoader();

        $(".machine-brand-dropdown").html("");

        var parameters = {
            machineDataType: machineDataTypes.MachineBrand,
            type: type

        };
        $.ajax({
            type: "Get",
            url: "/api/add-machine/machine-sub-categories",
            async: true,
            cache: false,
            data: parameters,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                if (response) {
                    var machineSubCategories = (typeof response.machineSubCategories === 'string') ? JSON.parse(response.machineSubCategories) : response.machineSubCategories;
                    $.each(machineSubCategories, function (index, machineSubCategory) {
                        $(".machine-brand-dropdown").append("<option value='" + machineSubCategory.Value + "'>" + machineSubCategory.Text + "</option>");
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching machine types!" + "</br>" + exception);
                $(".machine-brand-dropdown").html("Fel att hämta märke");
            },
            complete: function (response) {
                hideLoader();
                setSelectionList('.machine-brand-dropdown', false);
            }
        });
    };
    var fetchMachineModels = function (type, brand) {
        showLoader();
        $(".machine-model-dropdown").html("");

        var parameters = {
            machineDataType: machineDataTypes.MachineModel,
            type: type,
            brand: brand
        };

        $.ajax({
            type: "Get",
            url: "/api/add-machine/machine-sub-categories",
            async: true,
            cache: false,
            data: parameters,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                if (response) {
                    var machineSubCategories = (typeof response.machineSubCategories === 'string') ? JSON.parse(response.machineSubCategories) : response.machineSubCategories;
                    $.each(machineSubCategories, function (index, machineSubCategory) {
                        $(".machine-model-dropdown").append("<option value='" + machineSubCategory.Value + "'>" + machineSubCategory.Text + "</option>");
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching machine types!" + "</br>" + exception);
                $(".machine-model-dropdown").html("Fel att hämta Modell");
            },
            complete: function (response) {
                hideLoader();
                setSelectionList('.machine-model-dropdown', false);
            }
        });
    };
    var fetchMachineBrandsEvent = function () {
        $(document).on("change", ".machine-type-dropdown", function (event, data) {
            resetSelectionLists(machineDataTypes.MachineType);
            var type = getCurrentlySelectedMachineTypeId();
            if (type) {
                fetchMachineBrands(type);
            }
        });
    };
    var fetchMachineModelsEvent = function () {
        $(document).on("change", ".machine-brand-dropdown", function (event, data) {
            resetSelectionLists(machineDataTypes.MachineBrand);
            var type = getCurrentlySelectedMachineTypeId();
            var brand = getCurrentlySelectedMachineBrandId();
            if (type && brand) {
                fetchMachineModels(type, brand);
            }
        });
    };
    var getNewMachinePayload = function () {
        var selectedType = getCurrentlySelectedMachineTypeId();
        var selectedBrand = getCurrentlySelectedMachineBrandId();
        var selectedModel = getCurrentlySelectedMachineModel();
        var newMachinePayload = {
            MachineType: {
                Id: selectedType,
                Key: selectedType,
                Name: selectedType
            },
            MachineBrand: {
                Id: selectedBrand,
                Key: selectedBrand,
                Name: selectedBrand
            },
            MachineModel: {
                Id: selectedModel.Value,
                Key: selectedModel.Value,
                Name: selectedModel.Text
            },
            SerialNumber: getMachineSerialNumber(),
            RegisteringNumber:getMachineRegisteringNumber()

        };
        return newMachinePayload;
    }
    var getVerificationToken = function() {
        return $('#form-adding-machine input[name="__RequestVerificationToken"]').val();
    };

    var redirectToMachineStartPage = function() {
        var url = $(".js-page-identifier-machine").data("url");

        if (url !== "" && url !== undefined) {
            showLoader();
            window.location = url;
        }
    }
    var addMachineFillContentToModal = function (header, content, openDialog, dialogType, callback) {
        var dialogArea = $("#addMachineDialogArea");
        var iconElement = dialogArea.find("span.popup-type");
        if (dialogType) {
            iconElement.removeClass("hidden");
            iconElement.addClass(GroCommon.getModalIconClass(dialogType));
        } else {
            iconElement.addClass("hidden");
        }

        dialogArea.find(".lm__wide-modal__title").html(header);
        dialogArea.find("p").append(content);
        dialogArea.find(".btn-ok").on("click", function () {
            dialogArea.addClass("hidden");
            if (callback) {
                callback();
            }
        });
        if (openDialog) {
            dialogArea.removeClass("hidden");
        }
    };
    var addMachineClearContentToModal = function () {
        var dialogArea = $("#addMachineDialogArea");
        dialogArea.find("span.alert-icon.popup-type").removeClass("warning success info-icon");
        dialogArea.find(".lm__wide-modal__title").html("");
        dialogArea.find("p").html("");
        dialogArea.find(".btn-ok").unbind("click");
    };
    var addNewMachine=function()
    {
        if (validateFormAddMachine()) {
            showLoader();
            var errorList = [];
            var newMachinePayload = getNewMachinePayload();
            var token = getVerificationToken();
            $.ajax({
                type: "POST",
                url: "/api/add-machine/create",
                dataType: "json",
                async: true,
                cache: false,
                data: {
                    '__RequestVerificationToken': token,
                    'newMachine': JSON.stringify(newMachinePayload) },
                success: function (response) {
                    if (!response || response.isSaved == false) {
                        errorList.push("Fel att skapa ny maskin");
                    } else {
                        addMachineClearContentToModal();
                        addMachineFillContentToModal("Ny maskin skapad",
                            "Du skickas nu vidare till maskinstartsidan",
                            true,
                            dialogType.success,
                            redirectToMachineStartPage);
                    }
                },
                error: function (jqXHR, status, exception) {
                    errorList.push("Fel att skapa ny maskin "+ exception);
                    console.error("Something went wrong with the AJAX request for creating new machine " + "</br>" + exception);
                },
                complete: function (response) {
                    hideLoader();
                    showErrors(errorList);
                }
            });
        }

    }
    var addNewMachineEvent = function () {
        $(document).on("click", "#addNewMachineBtn", function (event) {
            addNewMachine();
        });
    };
    var init = function () {
        fetchMachineBrandsEvent();
        fetchMachineModelsEvent();
        resetSelectionLists(machineDataTypes.MachineType);
        addNewMachineEvent();
    };
    return {
        Init: init
    };
})();

var MachineBookingService = MachineBookingService || (function () {

    var dataMachines = null;

    function setDataMachines(data) {
        dataMachines = data;
    }

    function setOnclickMachineList(obj, data) {
        $(obj).find('p > a').click(function (e) {
            if (data != null && data.length > 0) {
                var machineId = $(this).parent().find('input[type="hidden"]').val();
                fillDetailMachine(data, machineId);
            }
            e.preventDefault();
        });
    }

    $(document).on('change', '#garageWorkshop', function () {
        var selectedValue = $(this).val();
        var cityInput = $("#City");
        cityInput.val(selectedValue);
        var facilityId = $('option:selected', this).data('facility-id');
        $('input[name="FacilityId"]').val(facilityId);
    });

    function getMachinesByCategory() {
        var key = $('#book-service-category').attr('data-value');
        $.ajax({
            url: '/api/book-service/get-machine-by-category?categoryKey=' + key,
            type: "GET",
            dataType: "json",
            success: function (data) {
                $('#book-service-loading').hide();
                $.each(data, function (i, machines) {
                    if (machines.length > 6) {
                        $('#book-machine-list-2').show();
                        $('#book-machine-list-1').hide();
                        var dropdown = $('#book-machine-list-2 > .address-sections > select');
                        dropdown.html('');
                        $.each(machines, function (j, machine) {
                            dropdown.append(
                                $('<option></option>').attr('value', machine.id).append(machine.modelName)
                            );
                        });
                        setDataMachines(machines);
                    }
                    else if (machines.length > 0 && machines.length <= 6) {
                        $('#book-machine-list-2').hide();
                        $('#book-machine-list-1').show();
                        var listSelectMachine = $('#book-machine-list-1 > .address-sections');
                        listSelectMachine.html('');
                        listSelectMachine.append($('<h3></h3>').addClass('lm__bold-title').append('Mina maskiner'));
                        $.each(machines, function (j, machine) {
                            listSelectMachine.append($('<p></p>').append(
                                $('<a></a>').addClass('lm__link').attr('href', '#').append(machine.modelName),
                                $('<input></input>').attr('type', 'hidden').val(machine.id)
                            ));
                        });
                        setOnclickMachineList(listSelectMachine, machines);
                    }
                    else {
                        $('#book-machine-list-2').hide();
                        $('#book-machine-list-1').hide();
                    }
                });
            },
        });
    }

    function getMachineById(listMachine, machineId) {
        var result = null;
        $.each(listMachine, function (i, machine) {
            if (machine.id.toString() == machineId.toString()) {
                result = machine;
            }
        });
        return result;
    }

    function fillDetailMachine(listMachine, machineId) {
        var machine = getMachineById(listMachine, machineId);
        console.log("fill machine details");
        var blockDetailMachine = $('#book-service-detail-machine').parent();
        if (machine != null) {
            blockDetailMachine.show();
            $('#book-service-detail-machine').html('');
            $('#book-service-detail-machine').append(
                $('<h2></h2>').addClass('heading-title-2').append('Vald maskin')
            );
            $('#book-service-detail-machine').append(
                $('<h3></h3>').addClass('lm__bold-title').append(machine.modelName)
            );

            $('#book-service-detail-machine').append(
                $('<p></p>').append(
                    $('<span></span>').addClass('lm__bold-title').append('Serienr'),
                    machine.serialNumber
                )
            );
            $('#book-service-detail-machine').append(
                $('<p></p>').append(
                    $('<span></span>').addClass('lm__bold-title').append('Regnr'),
                    machine.registerNumber
                )
            );
            blockDetailMachine.find("p > input[name=BrandAndModel]").val(machine.modelName);
            blockDetailMachine.find("p > input[name=SerialNumber]").val(machine.serialNumber);
            blockDetailMachine.find("p > input[name=RegisterNumber]").val(machine.registerNumber);
        }
        else {
            blockDetailMachine.hide();
            blockDetailMachine.find("p > input[name=BrandAndModel]").val('');
            blockDetailMachine.find("p > input[name=SerialNumber]").val('');
            blockDetailMachine.find("p > input[name=RegisterNumber]").val('');
        }
    }

    function bookingServiceSendFaild() {
        var result = $('#booking-service-send-faild').val();
        if (result != "" && result != undefined) {
            alert(result);
        }
    }

    var addMaskinTypeHandler = function () {
        // for choose Maskin Type in Book Service
        $(".maskin-type .showcase .dropdown li a").click(function () {
            $('#book-service-detail-machine').parent().hide();
            $('#book-machine-list-1').hide();
            $('#book-machine-list-2').hide();
            $('#book-service-loading').show();
            getMachinesByCategory();
        });
    };

    var addAddressHandler = function () {
        $("#book-machine-list-2 > .address-sections > select").change(function () {
            if (dataMachines != null && dataMachines.length > 0) {
                fillDetailMachine(dataMachines, $(this).val());
            }
        });
    };

    var addBookServiceFailedHandler = function () {
        //alert booking service send faild
        return bookingServiceSendFaild();
    };

    var init = function () {
        addMaskinTypeHandler();
        addAddressHandler();
        addBookServiceFailedHandler();
    };

    return {
        Init: init
    };
})();

export default MachineDetailPage;
